import type { ElementType, ReactNode } from "react";

import { cn } from "@/lib/utils";

export function Container({
  children,
  className,
  as: Tag = "div",
}: {
  children: ReactNode;
  className?: string;
  as?: ElementType;
}) {
  return <Tag className={cn("content-container", className)}>{children}</Tag>;
}
